import angular from 'angular';
import uploadSettingsComponent from './uploadSettings.component';
import uploadSettingsService from './uploadSettings.service';

let uploadSettingsModule = angular.module('uploadSettings', [])
  .component('uploadSettings', uploadSettingsComponent)
  .service('uploadSettingsService', uploadSettingsService);


export default uploadSettingsModule;



// WEBPACK FOOTER //
// ./app/components/uploadSettings/uploadSettings.js